import { render, staticRenderFns } from "./TableArea.vue?vue&type=template&id=76c517ba&scoped=true&"
import script from "./TableArea.vue?vue&type=script&lang=js&"
export * from "./TableArea.vue?vue&type=script&lang=js&"
import style0 from "./TableArea.vue?vue&type=style&index=0&id=76c517ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c517ba",
  null
  
)

export default component.exports